<h1 mat-dialog-title><i class="fa fa-file-text-o mr-2"></i>Add Note</h1>
<div mat-dialog-content class="mx-0">
    <app-panel-input></app-panel-input>
</div>
<div mat-dialog-actions class="justify-content-end px-4 mt-3 py-4">
    <button class="btn btn-outline-secondary mr-3">Cancel</button>
    <button class="btn btn-primary" type="submit">Create</button>
</div>
